<template>
  <b-modal 
    v-model="visible"
    @shown="setCategoryInput"
    title="Edytuj kategorię">
    <category-input ref="categoryInput" :options="options" :isBusy="isBusy" hide-add-button />
    <template v-slot:modal-footer="{cancel}">
      <b-button :disabled="isBusy || !isChanged" size="md" variant="primary" @click="ok">Tak</b-button>
      <b-button :disabled="isBusy" size="md" variant="outline-danger" @click="hide">Nie</b-button>
    </template>
  </b-modal>
</template>
<script>
import CategoryInput from './CategoryInput.vue';
export default {
  name: "editCategoryModal",
  data() {
    return {
      visible: false,
      options: [],
      item: null,
      isBusy: false
    }
  },
  computed:{
    isChanged() {
      if (!this.item || !this.$refs.categoryInput) return false;
      const {value: name, selected: parent_id} =  this.$refs.categoryInput.get();
      return name !== this.item.name || parent_id !== this.item.parent_id;
    }
  },
  methods: {
    show({ item, options }) {
      this.item = item;
      this.options = options;
      this.visible = true;
      this.isBusy = true;
    },
    setCategoryInput() {
      this.$refs.categoryInput.set({value: this.item.name, selected: this.item.parent_id});
      this.isBusy = false;
    },
    hide() {
      this.item = null;
      this.visible = false;
    },
    continue() {
      this.isBusy = false;
    },
    ok() {
      this.isBusy = true;
      const {value: name, selected: parent_id} =  this.$refs.categoryInput.get();
      this.$emit('ok',  {
        id: this.item.id,
        originalElement: this.item,
        body: {
          name, parent_id
        }
      });
    },
    error(error) {
      this.isBusy = false;
      console.error(error);
    }
  },
  components: {
    CategoryInput
  }
};
</script>